/**
 * 入力した数字がrangeConditionの範囲に収まっているかどうか調べる。配列の要素が１つのときは指定された値以上かどうかを確認する。
 * @param {[ number, number|null ]} rangeCondition
 * @param {number} price
 * @returns {boolean}
 */
const withinPriceRange = (rangeCondition, price) => {
  if (rangeCondition.length === 1) {
    return rangeCondition[0] <= price;
  } else if (rangeCondition.length === 2) {
    return rangeCondition[0] <= price && price <= rangeCondition[1];
  }
  return false;
};
export { withinPriceRange };
